var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { cachedSet } from '../../../../utils/mobx/decorators/customComputed';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { ImportingTreeSearch } from './ImportingTreeSearch';
import { flatten, uniq } from '../../../../utils/helper/lodash_replacements';
export class ImportingTree {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    get importingSearch() {
        return new ImportingTreeSearch(this);
    }
    get allImportingAspects() {
        return uniq(flatten(this.allImportingActors.map(actor => actor.actorAspects.allAspectsArray)));
    }
    get importingActorsFromExporting() {
        const relevantExportingActors = this.actor.exportingTree.allExportingActors.filter(a => !!a && a.type !== 'bundle');
        return relevantExportingActors;
    }
    get importingNodesFromExportingActors() {
        const importingNodesFromExportingActors = flatten(this.importingActorsFromExporting.map(actor => actor.importingTreeNode.allNodes));
        return importingNodesFromExportingActors;
    }
    get allImportingActors() {
        return uniq([...this.importingActorsFromExporting, ...this.importingNodesFromExportingActors]);
    }
    get allActiveTraits() {
        return this.allAttachedTraits.filter(at => at.attachedActive.isAtActive);
    }
    get allAttachedTraits() {
        return uniq(flatten(this.allImportingAspects.map(aspect => aspect.attachedTraits)));
    }
    get ownAttachedTraits() {
        return uniq(flatten(this.actor.actorAspects.allAspectsArray.map(aspect => aspect.regional.attachedTraits)));
    }
    attachedTraitsOfKey(traitKey) {
        return this.importingSearch.allActiveTraitsOfKey(traitKey);
    }
}
__decorate([
    memoize
], ImportingTree.prototype, "importingSearch", null);
__decorate([
    cachedSet
], ImportingTree.prototype, "allImportingAspects", null);
__decorate([
    cachedSet
], ImportingTree.prototype, "importingActorsFromExporting", null);
__decorate([
    cachedSet
], ImportingTree.prototype, "importingNodesFromExportingActors", null);
__decorate([
    cachedSet
], ImportingTree.prototype, "allActiveTraits", null);
__decorate([
    cachedSet
], ImportingTree.prototype, "allAttachedTraits", null);
__decorate([
    cachedSet
], ImportingTree.prototype, "ownAttachedTraits", null);
